// Angular
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
// Misc
import { has as _has } from 'lodash';
// rxjs
import { Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

// Store

// Models
import { claimFnolQuery, DraftClaim } from '@amfam/claim/fnol/data-access';
import { fromRouterActions } from '@amfam/shared/utility/navigation';

import * as fromRoot from '../../../core/store';

@Injectable()
export class FnolRiskLookInGuard {
  constructor(private store: Store<fromRoot.RootState>) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.store.select(claimFnolQuery.getClaimFnolSelectedEntity).pipe(
      take(1),
      switchMap((draftClaim: DraftClaim) => {
        if (
          _has(draftClaim, 'autoClaimDetail.vehicles') &&
          draftClaim.autoClaimDetail.vehicles.length > 0 &&
          draftClaim.autoClaimDetail.vehicles[0].vin
        ) {
          return of(true);
        }
        this.store.dispatch(
          fromRouterActions.Go({
            path: ['/claims/report-claim-fnol']
          })
        );
        return of(false);
      })
    );
  }
}
